export const getInitials = (source: string): string => {
    if (!source) return '?'
    const tokens = source.trim().split(/\s+/).slice(0, 2)
    const initials = tokens.map((token) => token[0]?.toUpperCase() ?? '').join('')
    return initials || '?'
}

// -------- helpers --------
export const getFirstName = (fullName: string): string => {
    const t = (fullName ?? '').trim()
    if (!t) return ''
    return t.split(/\s+/)[0] ?? ''
}

// simple {{key}} interpolation for PREVIEW only
export const interpolate = (tpl: string, data: Record<string, any>): string => {
    return (tpl ?? '').replace(/{{\s*([\w.]+)\s*}}/g, (_, key) => {
        const val = key.split('.').reduce((acc: any, k: any) => acc?.[k], data)
        return val == null ? '' : String(val)
    })
}
